export default __webpack_public_path__ + "locales/en/InfoPanel.json?hash=649aee2243c426f2f3d2c63fed526add";